import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=3d10ec52&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=3d10ec52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10ec52",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QHeader,QToolbar});
